const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/analyze/groups/users.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/analyze/groups/users")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    groupIds: z.array(z.number()).optional(),
    joining: z.union([z.literal("union"), z.literal("intersect")]).optional(),
    search: z.string().optional(),
    sortByColumn: z.string().optional(),
    sortDirection: z.union([z.literal("asc"), z.literal("desc")]).optional(),
    page: z.number().int().optional(),
    pageSize: z.number().int().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Users",
      description: "Page title"
    })
  }
});